import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Parse session_id from URL fragment
      const hash = location.hash || window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);

      if (!match) {
        navigate("/", { replace: true });
        return;
      }

      const sessionId = match[1];

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(response.data);
        // Clear the hash from URL
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: response.data } });
      } catch (error) {
        console.error("Auth failed:", error);
        navigate("/", { replace: true });
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#C5A059] animate-spin mx-auto mb-4" />
        <p className="text-[#4A5543] font-light">Welcoming you back...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
